import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getSurveyData } from './services/api';
import { h5PageCount } from '../../../utils';
import SurveyLogo from './surveyLogo';
import SurveyContent from './surveyContent';
import SurveyBar from './surveyBar';
import SurveyPopup from './surveyPopup';
import SurveyTitle from './surveyTitle';

const { callApp } = require('@ifeng-fe/callapp');

class Survey extends React.PureComponent {
    static propTypes = {
        surveyId: PropTypes.string,
        callAppConfig: PropTypes.object,
        clickCount: PropTypes.object, // {clickBar:xxx, clickCallApp: xxx, clickSubmit: xxx}
        isShowPopup: PropTypes.bool, //是否显示弹窗民调
        isShowBar: PropTypes.bool, //是否显示底部bar浮层引导
        isShowLogo: PropTypes.bool, //是否显示民调Logo
        isShowArticleSurvey: PropTypes.bool, //是否显示正文区民调
    };

    state = {
        isShowPopup: this.props.isShowPopup ?? false,
        isShowBar: this.props.isShowBar ?? true,
        isShowLogo: this.props.isShowLogo ?? true,
        isShowArticleSurvey: this.props.isShowArticleSurvey ?? true,
        data: {},
        status: '0',
        resultShow: false,
        isSubmitSurvey: false,
    };

    async componentDidMount() {
        try {
            const { surveyId } = this.props;

            console.log('surveyId', surveyId);

            const data = await getSurveyData(surveyId);

            if (data.ifsuccess) {
                // console.log(data.data);

                this.setState({
                    data: data.data,
                    status: data.data.surveyinfo.status,
                    // expire '0' 过期 '1' 过期
                    resultShow: data.data.surveyinfo.expire === '0',
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    handleCallupFn = () => {
        const { callAppConfig, clickCount } = this.props;

        if (clickCount?.clickCallApp) {
            h5PageCount([clickCount?.clickCallApp]);
        }

        if (callAppConfig) {
            callApp(callAppConfig);
        }
    };

    handleClickBar = () => {
        const { clickCount } = this.props;

        if (clickCount?.clickBar) {
            h5PageCount([clickCount?.clickBar]);
        }

        this.setState({
            isShowPopup: true,
        });
    };

    handleClosePopup = () => {
        this.setState({
            isShowPopup: false,
        });

        document.body.style.overflow = '';
        // document.body.style.position = '';
    };

    handleOptionSubmit = (type) => {
        const { clickCount } = this.props;

        if (clickCount?.clickSubmit) {
            if (clickCount.clickSubmit?.other) {
                clickCount.clickSubmit.other.pty = type === 2 ? 'mul' : 'single';
            }
            h5PageCount([clickCount?.clickSubmit]);
        }

        this.setState(
            {
                isSubmitSurvey: false,
            },
            () => {
                this.setState({
                    isSubmitSurvey: true,
                });
            },
        );
    };

    render() {
        const { callAppConfig } = this.props;
        const {
            data,
            status,
            resultShow,
            isShowPopup,
            isShowArticleSurvey,
            isShowBar,
            isSubmitSurvey,
            isShowLogo,
        } = this.state;

        return (
            status === '1' && (
                <Fragment>
                    {isShowArticleSurvey && (
                        <div className={styles.survey_box}>
                            {isShowLogo && <SurveyLogo data={data} />}
                            <SurveyContent
                                data={data}
                                resultShow={resultShow}
                                handleOptionSubmit={this.handleOptionSubmit}
                                isSubmitSurvey={isSubmitSurvey}
                                isShowJoin={!isShowLogo}
                            />
                        </div>
                    )}
                    {isShowBar && (
                        <SurveyBar data={data} isSubmitSurvey={isSubmitSurvey} handleClickBar={this.handleClickBar} />
                    )}
                    {isShowPopup && (
                        <SurveyPopup
                            callAppConfig={callAppConfig}
                            handleClosePopup={this.handleClosePopup}
                            handleCallupFn={this.handleCallupFn}>
                            <div className={styles.survey_box}>
                                <SurveyTitle data={data} />
                                <SurveyContent
                                    data={data}
                                    resultShow={resultShow}
                                    handleOptionSubmit={this.handleOptionSubmit}
                                    isSubmitSurvey={isSubmitSurvey}
                                    isShowJoin={true}
                                />
                            </div>
                        </SurveyPopup>
                    )}
                </Fragment>
            )
        );
    }
}

export default Survey;
